import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SplashScreen from '../pwa/SplashScreen';
import InvestorAdminLoginScreen from './InvestorAdminLoginScreen';

type FlowStage = 'splash' | 'login';

const InvestorAdminEntryFlow: React.FC = () => {
  const [stage, setStage] = useState<FlowStage>('splash');
  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = !!localStorage.getItem('investorAdminName') && !!localStorage.getItem('investorAdminId');
    if (isLoggedIn) {
      navigate('/investor-pwa/admin/dashboard', { replace: true });
      return;
    }

    if (stage === 'splash') {
      const timer = setTimeout(() => {
        setStage('login');
      }, 1200);

      return () => clearTimeout(timer);
    }
  }, [stage, navigate]);

  if (stage === 'splash') {
    return <SplashScreen />;
  }

  return <InvestorAdminLoginScreen onSuccess={() => navigate('/investor-pwa/admin/dashboard')} />;
};

export default InvestorAdminEntryFlow;
